import uuid from 'uuid/v4';
import { shuffle, filter, first } from 'lodash';


const cardRevealDuration = Symbol('cardRevealDuration');
const revealed = Symbol('revealed');

export default class Board {
  id = uuid('board');
  size = 0;
  cardPool = [];
  cards = [];
  selected = [];
  found = [];

  [cardRevealDuration] = 1500;
  [revealed] = false;

  constructor(size, cardPool) {
    this.size = size;
    this.cards = this.getEmptyCardsArray();
    this.cardPool = cardPool;

    if (this.cards.length % 2 !== 0) {
      throw new Error('The number of cards must be even. This is a game of PAIRS.');
    }

    if (cardPool.length < 1) {
      throw new Error('The card pool must not be empty.');
    }

    if (cardPool.length < (this.cards.length / 2)) {
      throw new Error('The card pool is too small for such a big board.');
    }

    this.dealCards();
    this.shuffleCards();
  }

  get foundAllPairs() {
    return this.found.length === this.cards.length;
  }

  get selectedPairMatches() {
    const { selected } = this;

    if (selected.length !== 2) {
      return false;
    }
    const cards = selected.map(id => this.getCardById(id));
    return cards[0].src === cards[1].src;
  }

  getEmptyCardsArray() {
    const { size } = this;
    return (new Array(size * size)).fill(null);
  }

  dealCards() {
    let { cardPool } = this;
    const { size } = this;
    const requiredCardTypes = ((size * size) / 2);
    const cards = [];

    cardPool = shuffle(cardPool);

    for (let i = 0; i < requiredCardTypes; i += 1) {
      const card1 = cardPool.pop();
      const card2 = card1.clone();
      cards.push(card1);
      cards.push(card2);
    }

    this.cards = cards;
  }

  shuffleCards() {
    this.cards = shuffle(this.cards);
  }

  selectCard(id, callback) {
    if (this.isSelected(id) || this.isFound(id)) {
      return;
    }

    if (this[revealed]) {
      return;
    }

    callback();
    this.selected.push(id);

    if (this.selected.length === 2) {
      this[revealed] = true;
      let revealDuration = this[cardRevealDuration];

      if (this.selectedPairMatches) {
        revealDuration = 0;
        this.found = [...this.found, ...this.selected];
      }

      setTimeout(() => {
        this[revealed] = false;
        this.deselectAllCards();
      }, revealDuration);
    }
  }

  deselectAllCards() {
    this.selected = [];
  }

  getCardById(id) {
    return first(filter(this.cards, { id }));
  }

  isSelected(id) {
    return this.selected.indexOf(id) !== -1;
  }

  isFound(id) {
    return this.found.indexOf(id) !== -1;
  }
}
